import { ComponentPropsWithRef, ReactNode } from 'react';
import { clsx } from 'clsx';
import { textVariantClasses } from './Text';
import { Spinner } from '../Spinner';

interface ButtonProps extends ComponentPropsWithRef<'button'> {
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost';
  size?: 'sm' | 'md' | 'lg' | 'smIcon' | 'mdIcon' | 'lgIcon';
  loading?: boolean;
  children?: ReactNode;
}

export const buttonBaseClasses =
  'inline-flex items-center justify-center rounded-md border border-transparent-dark-16 gap-4xs transition-all ease-in-out duration-150 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed focus:outline-2 focus:outline-offset-2';

export const buttonVariantClasses = {
  primary:
    'bg-brand-default text-base-white shadow-button-primary hover:bg-brand-emphasis outline-brand-subtle',
  secondary:
    'bg-base-white text-neutral-default shadow-button-secondary hover:bg-neutral-subtle outline-neutral-subtle',
  danger:
    'bg-error-default text-base-white shadow-button-primary hover:bg-error-muted outline-error-subtle',
  ghost:
    'bg-transparent text-neutral-default hover:bg-neutral-subtle outline-neutral-subtle border-none',
};

export const sizeClasses = {
  sm: `px-xs py-2xs ${textVariantClasses['label-sm-strong']}`,
  md: `px-md py-xs ${textVariantClasses['label-sm-strong']}`,
  lg: `px-lg py-sm ${textVariantClasses['label-md-strong']}`,
  smIcon: 'size-[36px]',
  mdIcon: 'size-[40px]',
  lgIcon: 'size-[46px]',
};

export function Button({
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled,
  children,
  className,
  ...props
}: ButtonProps) {
  return (
    <button
      className={clsx(
        buttonBaseClasses,
        buttonVariantClasses[variant],
        sizeClasses[size],
        className
      )}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? <Spinner color={variant === 'secondary' ? 'black' : 'white'} /> : children}
    </button>
  );
}
